(function ($) {
  var scrollToTopButton = '#to-top';

  function showToTop() {
    if ($(this).scrollTop() > 100) {
      $(scrollToTopButton).addClass('show');
    } else {
      $(scrollToTopButton).removeClass('show');
    }
  }

  $(window).on('scroll', function () {
    showToTop();
  });


  $(window).on('ready', function () {
    showToTop();
  });

  $(scrollToTopButton).on('click', function (e) {
    $('body,html').animate({
      scrollTop: 0
    }, 800);
    return false;
  });
})(jQuery);
